/* eslint-disable react-hooks/exhaustive-deps */
import { Grid } from "@mui/material";
import React from "react";
import AppLayout from "../../../../layout/DashboardLayout";
import { useSelector } from "react-redux";
import DataStatisticsChart from "./components/DataStatisticsChart";
import TopSellingProducts from "./components/TopSellingProducts";
import ProductSourceReviewTab from "../products/components/ProductSourceReviewTab";
import OrderTrackingTabs from "./components/OrderTrackingsTabs";
import AttentionData from "./components/AttentionData";
import TopHeader from "./components/TopHeader";
import searchIcon from "../../../../assets/img/checkmark.png";
import OrderStatistics from "./components/OrderStatistics";
import { storeSelector } from "../../../../redux/slices/storeSlice";
import useWindowWidth from "../../../../hooks/useWindowWidth";
import { authSelector } from "../../../../redux/slices/authSlice";

function DummyDashboard({ storeOwner }) {
  const { shopifyAppStore,shopifyAppUserDetails  } = useSelector(storeSelector);
  const { sideBarExpand } = useSelector(authSelector);
  const [value, setValue] = React.useState(0);
  const windowWidth = useWindowWidth();

  return (
    <AppLayout>
      <div
        style={{
          position: "absolute",
          backgroundColor: "#220d48",
          background: "linear-gradient(280deg, #341073 0%, #210D44 101.66%)",
          height: windowWidth <= 1500 ? "280px" : "310px",
          padding:
            windowWidth <= 1650 ? "10px 0px 20px 0px" : "10px 0px 20px 0px",
          right: "0%",
          marginTop: "-10px",
          left: sideBarExpand ? "16%" : "0%",
          transition: "all 0.3s ease-in-out",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            maxWidth: "1600px",
            padding:
              windowWidth <= 1650
                ? "10px 40px 20px 20px"
                : "10px 60px 20px 40px",
          }}
        >
          <TopHeader
            userName={shopifyAppStore?.shop_details?.shop_owner || shopifyAppUserDetails?.shop_details?.shop_owner || storeOwner}
            windowWidth={windowWidth}
          />
          <Grid container spacing={windowWidth <= 1700 ? 2 : 4}>
            <Grid item xs={9}>
              <DataStatisticsChart
                storeOwner={storeOwner}
                // ordersTotalCount={totalCount}
              />
              <Grid
                container
                spacing={windowWidth <= 1700 ? 2 : 4}
                sx={{ marginTop: "60px", paddingLeft: "20px" }}
              >
                <OrderStatistics storeOwner={storeOwner} />
              </Grid>
              <Grid
                container
                spacing={windowWidth <= 1700 ? 2 : 4}
                sx={{ paddingLeft: "20px", marginTop: "0px" }}
              >
                <Grid item xs={6} style={{ marginBottom: "20px" }}>
                  <OrderTrackingTabs
                    height="450px"
                    storeOwner={storeOwner}
                    value={value}
                    setValue={setValue}
                  />
                </Grid>
                <Grid item xs={6} style={{ marginBottom: "20px" }}>
                  <ProductSourceReviewTab
                    height="450px"
                    overflow="scroll"
                    storeOwner={storeOwner}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={3}>
              <div
                style={{
                  borderRadius: "8px",
                  padding: windowWidth <= 1500 ? "10px" : "20px 25px",
                  background: "#fff",
                  boxShadow: "rgba(17, 17, 26, 0.1) 0px 0px 16px",
                  height: "400px",
                }}
              >
                <h4 style={{ fontSize: windowWidth <= 1500 ? "16px" : "18px" }}>
                  Attention
                </h4>

                <AttentionData
                  windowWidth={windowWidth}
                  storeOwner={storeOwner}
                />

                <div style={{ textAlign: "center" }}>
                  <img src={searchIcon} alt="" style={{ width: "200px" }} />

                  <p
                    style={{
                      fontSize: "22px",
                      fontWeight: "700",
                      color: "black",
                      lineHeight: 0.5,
                      marginTop: -20,
                    }}
                  >
                    You 're all set
                  </p>
                  <h6 style={{ lineHeight: 1.5 }}>
                    No orders currently need extra attention
                  </h6>
                </div>
              </div>
              {
                <div style={{ background: "white", borderRadius: "8px" }}>
                  <TopSellingProducts storeOwner={storeOwner} />
                </div>
              }
            </Grid>
          </Grid>
        </div>
      </div>
    </AppLayout>
  );
}
export default DummyDashboard;
